<template>
  <a-input
      v-show="info.status === 'edit'"
      v-model:value="data[propName]"
      :maxlength="widget.length"
      :placeholder="'请填写' + info.title"
  />
  <div v-show="info.status === 'show'" class="view">
    <a-tooltip :title="showLong(data[propName], 30)" placement="top">
      <div class="show">
        {{ ellipsis(data[propName], 30) }}
      </div>
    </a-tooltip>
  </div>
</template>

<script lang="ts" setup>
import {defineProps} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import TextTable from "./TextTable.vue";
import {TextFieldType} from "@/components/business/crud/interface/FieldType";

const props = defineProps<{
  propName: string;
  widget: TextFieldType;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();

function ellipsis(text: string | undefined, max: number) {
  if (!text) {
    return "";
  }
  if (text.length <= max) {
    return text;
  } else {
    return text.slice(0, max - 3) + "..."
  }
}

function showLong(text: string | undefined, max: number) {
  if (!text) {
    return "";
  }
  if (text.length > max) {
    return text;
  }
}
</script>

<style lang="scss" scoped>
.view {
  height: 100%;
  padding-left: 12px;
}
</style>
